import { RG_TYPE, sum, RgCreate, roundDecimals, isInRange } from "@project-rouge/rg-core";
import { getPolygonArea, getPivot, randomShadeOfColour } from "@project-rouge/rg-three";
function createTechSpaceRooms(techSpace, dataset, includes) {
  const techSpaceArea = techSpace.data.polygon ? getPolygonArea(techSpace.data.polygon) : techSpace.size[0] * techSpace.size[2];
  const modules = techSpace.children.filter((c) => c.type === RG_TYPE.Module);
  const maxZ = Math.max(...modules.map((m) => m.size[2]));
  if (includes && includes.length > 0) {
    const minSizes = includes.map((s) => getMinimumSize(s));
    const minAreas = minSizes.map((s) => s[0] * s[2]);
    const totalRoomsArea = minAreas.reduce(sum);
    const roomAnchor = [0.5, 0, 0.5];
    const previousPosition = [
      -techSpace.size[0] * techSpace.anchor[0],
      0,
      -techSpace.size[2] * techSpace.anchor[2]
    ];
    for (let i = 0; i < includes.length; i++) {
      const included = includes[i];
      const minSize = minSizes[i];
      const pos = previousPosition.slice();
      const prelimPos = [previousPosition[0], previousPosition[1], previousPosition[2] + roomAnchor[2] * minSize[2]];
      const area = minAreas[i] / totalRoomsArea * techSpaceArea;
      const module = modules.find((m) => isPosInsideModule(prelimPos, m));
      const sizeZ = module ? module.size[2] : maxZ;
      const sizeX = area / sizeZ;
      pos[0] = previousPosition[0] + sizeX * roomAnchor[0];
      pos[2] = (module ? getPivot([0.5, 0, 0], module).z : 0) + sizeZ * roomAnchor[2];
      const techRoom = RgCreate({
        type: RG_TYPE.TechnicalSpaceRoom,
        children: [],
        anchor: roomAnchor.slice(),
        size: [sizeX, techSpace.size[1], sizeZ],
        pos,
        data: { instance: included },
        parent: techSpace,
        color: randomShadeOfColour("#BE29EC")
      }, dataset.rvData);
      previousPosition[0] += techRoom.size[0];
      techSpace.children.push(techRoom);
    }
  } else {
    const pos = [0, 0, -techSpace.size[2] * techSpace.anchor[2]];
    const roomAnchor = [0.5, 0, 0];
    const module = modules.find((m) => isPosInsideModule(pos, m));
    const size = getMinimumSize(techSpace.data.instance);
    size[0] = size[0] === 0 ? techSpace.size[0] : size[0];
    size[1] = size[1] === 0 ? techSpace.size[1] : size[1];
    size[2] = size[2] === 0 ? techSpace.size[2] : size[2];
    const area = size[0] * size[2];
    size[2] = module ? Math.min(size[2], module.size[2]) : Math.min(size[2], techSpace.size[2]);
    size[0] = area / size[2];
    size[1] = techSpace.size[1];
    pos[2] = (module ? getPivot([0.5, 0, 0], module).z : 0) + size[2] * roomAnchor[2];
    const techRoom = RgCreate({
      type: RG_TYPE.TechnicalSpaceRoom,
      name: techSpace.data.instance.name,
      size,
      children: [],
      data: { instance: techSpace.data.instance },
      anchor: roomAnchor,
      pos,
      parent: techSpace,
      color: randomShadeOfColour("#BE29EC")
    }, dataset.rvData);
    techSpace.children.push(techRoom);
  }
}
function getMinimumSize(space) {
  const minX = space.attributes.sizeX ? space.attributes.sizeX[0] : 0;
  const minY = space.attributes.sizeY ? space.attributes.sizeY[0] : 0;
  const minZ = space.attributes.sizeZ ? space.attributes.sizeZ[0] : 0;
  const minArea = space.attributes.area ? space.attributes.area[0] : 0;
  const size = [minX, minY, minZ];
  if (minX && !minZ && minArea)
    size[2] = minArea / size[0];
  else if (!minX && minZ && minArea)
    size[0] = minArea / size[2];
  return size;
}
function isPosInsideModule(pos, module) {
  const tol = 0.015;
  const x = [roundDecimals(module.pos[0] - module.size[0] * module.anchor[0], 2), roundDecimals(module.pos[0] + module.size[0] * (1 - module.anchor[0]), 2)];
  const y = [roundDecimals(module.pos[1] - module.size[1] * module.anchor[1], 2), roundDecimals(module.pos[1] + module.size[1] * (1 - module.anchor[1]), 2)];
  const z = [roundDecimals(module.pos[2] - module.size[2] * module.anchor[2], 2), roundDecimals(module.pos[2] + module.size[2] * (1 - module.anchor[2]), 2)];
  const inside = (isInRange(roundDecimals(pos[0] - tol, 2), x[0], x[1]) || isInRange(roundDecimals(pos[0] + tol, 2), x[0], x[1])) && isInRange(roundDecimals(pos[1], 2), y[0], y[1]) && isInRange(roundDecimals(pos[2], 2), z[0], z[1]);
  return inside;
}
export {
  createTechSpaceRooms
};
//# sourceMappingURL=index61.js.map
